<template>
  <div class="cbox">
    <input v-if="multiple" :id="'QuestionnaireInput_option' + _uid" type="checkbox" :checked="isInitiallyChecked" :value="answerId" v-on:change="changed" :name="'QuestionnaireInput_question_' + questionId" />
    <input v-else :id="'QuestionnaireInput_option' + _uid" type="radio" :checked="isInitiallyChecked" :value="answerId" v-on:change="changed" :name="'QuestionnaireInput_question_' + questionId" />
    <label :for="'QuestionnaireInput_option' + _uid">
      <span>
        <span></span>
      </span>
      <p>{{label}}</p>
    </label>
  </div>
</template>

<script>
export default {
  name: 'QuestionnaireInput',
  props: {
    questionId: Number,
    answerId: String,
    questionnaire: Object
  },
  data() {
    return {
      multiple: this.questionnaire.questions[this.questionId].multiple,
      label:  this.$t('answers.' + this.questionId + '.' + this.answerId),
      isInitiallyChecked: this.questionnaire.getAnswers(this.questionId).indexOf(this.answerId) !== -1
    }
  },
  methods: {
    changed() {
      if (this.multiple) {
        var answers = this.questionnaire.getAnswers(this.questionId)
        if(answers.indexOf(this.answerId) === -1) answers.push(this.answerId)
        else answers.splice(answers.indexOf(this.answerId), 1)
        this.questionnaire.setAnswers(this.questionId, answers)
      } else {
        this.questionnaire.setAnswers(this.questionId, [this.answerId])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cbox {
  display: inline-block;
  font-size: 1.25em;
  margin-right: 1.5em;
  input:not(old) {
    width: 2em;
    margin: 0;
    padding: 0;
    font-size: 1em;
    opacity: 0;
  }
  input:not(old)+label {
    display: inline-block;
    margin-left: -2.5em;
    line-height: 1.5em;
  }
  input:not(old)+label>span {
    display: inline-block;
    width: 0.975em;
    height: 0.975em;
    margin: 0.25em 0.5em 0.25em 0.25em;
    border: 0.1125em solid rgb(103, 103, 107);
    background: white;
    vertical-align: top;
    position: relative;
  }
  input:not(old):checked+label>span>span {
    display: block;
    width: 0.5em;
    height: 0.5em;
    background: rgb(0, 155, 123);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
  }
  p {
    font-size: 0.8em;
    display: inline;
  }
}
</style>


// WEBPACK FOOTER //
// src/Questionnaire/QuestionnaireInput.vue